"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.number.constructor");
var _index = require("@/utils/index");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/**
 * 修改可提现金额
 */
var _default = exports.default = {
  props: {
    // 1 代理 2 商户
    type: {
      type: Number,
      default: 1
    }
  },
  data: function data() {
    return {
      editWithDialog: false,
      withList: [],
      editWith: {},
      setRow: {},
      activeTab: '跟进记录',
      tabs: ['历史跟进']
    };
  },
  mounted: function mounted() {},
  methods: {
    /**
     * 显示dialog
     */
    showDialog: function showDialog(row) {
      this.editWithDialog = true;
      this.setRow = row;
      this.editWith.son_id = row.id;
      this.getList(row.id);
    },
    /**
     * 获取修改记录
     */
    getList: function getList(id) {
      var _this = this;
      this.$get('agentapi/business/agent_follow_up', {
        son_id: id
      }).then(function (res) {
        _this.withList = res.list;
      });
    },
    /**
     * 获取修改记录
     */
    onSubmit: function onSubmit() {
      var _this2 = this;
      this.loadObj = this.$loading({
        lock: true,
        text: '正在提交',
        spinner: 'el-icon-loading'
      });
      this.$post('agentapi/business/agent_follow_up', this.editWith).then(function (res) {
        _this2.editWithDialog = false;
        _this2.editWith = {};
        _this2.loadObj.close();
        _this2.$message({
          message: '提交成功',
          type: 'success'
        });
      }).catch(function (err) {
        _this2.loadObj.close();
      });
    }
  }
};